<div class="container" style="margin-top: 100px;">
    <div class="container-fluid section-t-space px-0">
        <div class="page-content">
            <div class="content-center w-100">
                <div class="friend-list-box section-b-space">
                    <div class="card-title">
                        <div class="row w-100 align-items-center mb-3">
                            <div class="col-lg-6 d-flex align-items-center gap-3">
                                <div class="skeleton-loader" style="width: 100px; height: 30px; border-radius: 4px;"></div>
                                <div class="skeleton-loader" style="width: 200px; height: 38px; border-radius: 4px;"></div>
                            </div>
                            <div class="col-lg-6">
                                <div class="skeleton-loader" style="width: 60%; height: 38px; margin-left: auto; border-radius: 4px;"></div>
                            </div>
                        </div>
                        <div class="row w-100 align-items-center">
                            <div class="col-lg-6 d-flex align-items-center gap-3">
                                <div class="skeleton-loader" style="width: 80px; height: 30px; border-radius: 4px;"></div>
                                <div class="skeleton-loader" style="width: 200px; height: 38px; border-radius: 4px;"></div>
                            </div>
                            <div class="col-lg-6">
                                <div class="skeleton-loader" style="width: 150px; height: 20px; margin-left: auto; border-radius: 4px;"></div>
                            </div>
                        </div>
                    </div>
                    <div class="container-fluid">
                        <div class="friend-list friend-page-list">
                            <ul>
                                @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                                <li>
                                    <div class="profile-box friend-box">
                                        <div class="profile-content">
                                            <div class="image-section">
                                                <div class="profile-img skeleton-loader" style="width: 100px; height: 100px; border-radius: 50%;"></div>
                                            </div>
                                            <div class="profile-detail">
                                                <div class="skeleton-loader" style="width: 150px; height: 24px; margin-bottom: 10px; border-radius: 4px;"></div>
                                                <div class="skeleton-loader" style="width: 100px; height: 36px; border-radius: 4px;"></div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
.skeleton-loader {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
